import { Component, inject } from '@angular/core';
import { UnauthPageIntroComponent } from '../../components/unauth-page-intro/unauth-page-intro.component';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';
import { UnauthenticatedForwardNavService } from '../../services/unauthenticated-forward-nav.service';
import { PUBLIC_MARKETING_RUNTIME_CONFIG } from '../../tokens/public-marketing-runtime.token';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [UnauthenticatedPageComponent, UnauthPageIntroComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['../about-project/about-project.component.css'],
})
export class PrivacyPolicyComponent {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);
  private readonly marketing = inject(PUBLIC_MARKETING_RUNTIME_CONFIG);

  readonly appName = this.marketing.appName;
  readonly pageTitle = 'Privacy Policy';
}
